import React, {Fragment, useEffect, useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFile, faDownload } from '@fortawesome/free-solid-svg-icons';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {Form,Button,Spinner,} from 'react-bootstrap';
import axios from 'axios';
import Recepisse from '../../components/RecepisseDepot/index'
import Input from '../../components/Input';
import InputT from '../../components/Input';
import { InputF } from '../../components/Input';
import { InputOption } from '../../components/Input';
import Alert, { Alert2 } from '../../components/Alerte';
import Update from '../Update/index';
import './voyage.css'
import Env from '../../hooks/Env';

const email = ['alassane.diallo@uam.edu.sn',
'ousmane.khouma@uam.edu.sn',
'jonas.malou@uam.edu.sn',
'moussa.diakhate@uam.edu.sn',
'ibrahima.mall@uam.edu.sn',
'amy.gueye@uam.edu.sn',
'bocar.sy@uam.edu.sn',
'alioune.coulibaly@uam.edu.sn',
'siny.ndoye@uam.edu.sn',
'thierno.sow@uam.edu.sn',
'makha.ndao@uam.edu.sn',
'lalla.ba@uam.edu.sn',
'babacar.ngom@uam.edu.sn',
'serigne.pouye@uam.edu.sn',
'kemo.balde@uam.edu.sn',
'serigne.wade@uam.edu.sn',
'ibrahima.cisse@uam.edu.sn',
'roger.faye@uam.edu.sn',
'maryam.mbacke@uam.edu.sn',
'mababa.diagne@uam.edu.sn',
'amadou.ndiaye@uam.edu.sn',
'serigne.wade@uam.edu.sn',
'ibrahima.dia@uam.edu.sn',
'maurice.dasylva@uam.edu.sn',
'maryam.mbacke@uam.edu.sn',
'issa.sakho@uam.edu.sn',
'awa.mar@uam.edu.sn',
'babacar.ndiaye@uam.edu.sn',
'richard.diop@uam.edu.sn',
'tahir.diop@uam.edu.sn',
'mansour.tall@uam.edu.sn',
'amina.gaye@uam.edu.sn',
'youssouph.sane@uam.edu.sn',
'lamane.mbaye@uam.edu.sn',]
const renderTooltip = (props) => (
    <Tooltip id="button-tooltip"  {...props}>
      Ajouter un nouveau fichier
    </Tooltip>
  );
  const IconForFile = (props) => {
    return (
        <>
        <OverlayTrigger
            placement="right"
            delay={{ show: 100, hide: 400 }}
            overlay={renderTooltip}
            >
            <FontAwesomeIcon onClick={() => {props.toggleInputVisibility(props.name)}} icon={faFile} className='btn btn-primary mr-2' />
        </OverlayTrigger>
        </>
    )
  }
const Voyage = ({props}) => {
    const API_URL = Env().API_URL ;
    const [InputVisible, SetInputVisible] = useState({
        'communication5':false,
        'justificatif':false,
        'diplome':false,
    })
    const toggleInputVisibility = (state) => {
        const updatedInputVisible = { ...InputVisible };
        updatedInputVisible[state] = !updatedInputVisible[state];
        SetInputVisible(updatedInputVisible);
    }
    const removeFile = (fieldName,state) => {
        console.log("Au moment ",selectedFiles.publication7)
        const updatedInputVisible = { ...InputVisible };
        updatedInputVisible[state] = !updatedInputVisible[state];
        SetInputVisible(updatedInputVisible);
        // Créez une copie de l'état actuel
        const updatedFiles = { ...selectedFiles };
      
        // Supprimez l'élément spécifique
        updatedFiles[fieldName] = null;
      
        // Mettez à jour l'état avec la nouvelle copie
        setSelectedFiles(updatedFiles);
        console.log("Aprés mise à jour ",selectedFiles.publication7)
      };
    const [dataForm, setDataForm] = useState('');
    const [nationalities, setNationalities] = useState([]);
    const [step, setStep] = useState(1);
    const [update,setUpdate] = useState(false)
    const [valid, SetIsValid] = useState({
        isValidPhoneNumber: false,
        isValidEmail: false
      });
    const [message, setMessage] = useState('')
    const [typefille, setTypeFile] = useState(false)
    const[ messageAlerte, setMessageAlerte] = useState('')
    const [errors, setErrors] = useState(false);
    const [depotsuccess, setDeppotSuccess] = useState(false);
    const [depotsuccess2, setDeppotSuccess2] = useState(false);
    const maxFileSize = 1024 * 1024 * 2; //1Mo
    const [show, setShow] = useState(false);
    const [complete, setComplete] = useState(false);
    const handleClose = () => setShow(false);
    const [selectedFiles, setSelectedFiles] = useState({
        "compte_rendu":true,
        "arrete" : true,
        "justificatif" : true,
    });
    const [gestionfichier, setGestionFichier] = useState({
        "compte_rendu":false,
        "arrete" : false,
        "justificatif" : false,
    });
    const [erreur,setErreur] = useState(false)
    const [submitted, setSubmitted] = useState(false);
    const [data, setData] = useState();  /*données d'un user avec dépot réussie */
    const handleFileChange = (event, key) => {
        // console.log(selectedFiles.publication7)
        var file = event.target.files[0];
        console.log(file)
            const elements = document.getElementsByName(key)
            if (file?.size < maxFileSize){
                setTypeFile(false)
                setSelectedFiles((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: file
                }));
                setGestionFichier((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: true
                }));
                for (var i = 0; i < elements.length; i++) {
                    var element1 = elements[i];
                    // console.log(element)
                    // Faites quelque chose avec chaque élément, par exemple :
                    element1.style.border = ""; // Applique une bordure rouge
                    // ... autres opérations sur l'élément
                }
            } else {
                setSelectedFiles((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: false
                }));
                setGestionFichier((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: false
                }));
                for (var j = 0; j < elements.length; j++) {
                    var element = elements[j];
                    // console.log(element)
                    // Faites quelque chose avec chaque élément, par exemple :
                    element.style.border = "2px solid #BC0C0C";
                    element.style.transition ='border 0.5s ease-in-out;' // Applique une bordure rouge
                    // ... autres opérations sur l'élément
                }

            }
    };

      // Exemple d'utilisation
    function handleChange (e) {
        const name= e.target.name;
        let value = e.target.value;
        // console.log(value,name)
        if (name === 'telephone' ) {
            const phoneRegex = /^\d{9}$/;  //validation numéro de téléphone
            SetIsValid((valid) => ({
                ...valid,
                isValidPhoneNumber: phoneRegex.test(value),
            }));
        }
        if (name === 'email') {
            //validation email
            var element = document.getElementsByName('email')
            element = element[0]
            const emailRegex = /^[a-zA-Z0-9._%+-]+(?:\.[a-zA-Z0-9._%+-]+)+@uam\.edu\.sn$/;
            SetIsValid((valid) => ({
                ...valid,
                isValidEmail: emailRegex.test(value),
            }));
        }
        setDataForm({ ...dataForm, [name]: value });
        // console.log(value,name)
    }
    const handleNextStep = () => {
        if (step === 1) {
            if (!valid['isValidEmail']) {
                setErreur(true)
                setErrors(false)
            } else {
                axios({
                    url:`${API_URL}/voyage/confirmed/?email=${dataForm.email}`,
                    method: 'POST',
                }) 
                .then(result => {
                    if (result.data.data){
                        setErreur(true)
                    } else {
                        setErreur(false)
                        if (!dataForm.email || !dataForm.grade || !dataForm.prenom|| !dataForm.nom || !dataForm.matricule || !dataForm.theme_recherche
                            || !dataForm.diplome || !dataForm.lieu_diplome || !dataForm.etablissement_diplome || !dataForm.fonction || !dataForm.date_recrutement 
                        ) {
                            setErrors(true)
                        }
                        else {
                            setErrors(false)
                            setStep(step + 1)
                        }
                    }
                    //window.location.href = result.data.paymentURL;
                })
                .catch((error) => {
                    console.error('Error:', error);
                    setSubmitted(false);
                });
            }
            
        } else if (step === 2) {
            setErrors(false);
            setStep(step + 1);
                // if (dataForm.structure1 && dataForm.naturestructure1 && dataForm.structure2 && dataForm.naturestructure2 && dataForm.structureinter1 && dataForm.naturestructureinter1 &&
                //     dataForm.structureinter2 && dataForm.naturestructureinter2) {
                //     setErrors(false);
                //     setStep(step + 1);
                //    } else {
                //         setErrors(true);
                // }  
            }
    };
  
    const handlePreviousStep = () => {
      setStep(step - 1);
    };
    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            const formData = new FormData();
            const nameFiles = ["compte_rendu","arrete","justificatif"]
            for (const i in nameFiles) {
                if (selectedFiles[nameFiles[i]]) {
                    if ((selectedFiles[nameFiles[i]]).size <= maxFileSize) {
                        formData.append(nameFiles[i] , selectedFiles[nameFiles[i]])
                    } else {
                        // console.log("fichier trop gros");
                    }
                }
            }
            for (let key in dataForm) {
                // console.log(dataForm[key])
                if (dataForm.hasOwnProperty(key)) {
                      if( dataForm[key] !== null) {
                        if (key === 'pays') {
                            if (dataForm['type_poste'] === 'PATS') {
                                if (dataForm['pays'] !== 'senegal') {
                                    dataForm['pays'] = 'SENEGAL'
                                }
                            }
                        }
                        formData.append(key ,dataForm[key])
                      }
              }
            }
            var showALerte = nameFiles.some(field => selectedFiles[field] === false);
         for (let pair of formData.entries()) {
                console.log(pair[0] + ':' + pair[1]);
              }
        console.log(selectedFiles)
            if (showALerte) {
                 setShow(true);
                 console.log('erreur sur les fichiers')
                //  setOk(false)
            }
            else if (typefille) {
                alert('format de fichier incoorecte !')
            }
            else {
                setComplete(true)
                setSubmitted(true);
                // console.log("Requete en cours d'envoi ...")
                const response = await axios.post(
                    `${API_URL}/voyage/`,
                    formData,
            {
                    headers: {
                    'Content-Type': 'multipart/form-data',
                    },
                    });
            // console.log(response)
            if (response.status === 200) {
                if (response.data.detail) {
                    setSubmitted(false);
                    // console.log(response.data.detail)
                    setDeppotSuccess2(true)
                } else {
                    // console.log(response)
                    setSubmitted(false);
                    // console.log('Files uploaded successfully');
                    // console.log('Recepissé :' + response?.data?.data)
                    const dataPersonDepot = response?.data?.data;
                    setData(dataPersonDepot);
                    setDeppotSuccess(true);
                    // console.log("message : " + response.data.message);
                    // console.log(data);
                }
            } else {
                console.error('Error uploading files');
                console.log("Détail de la réponse ",response.status)
            }
        }
    } catch (error) {
        setSubmitted(false);
       console.error('Error', error);
    }
};
    const calculateProgress = () => {
        // Calculez le pourcentage de progression en fonction du numéro d'étape
        return (step / 3) * 100; // Supposons que vous ayez 3 étapes au total
      };
    
  return (
    <>
    <Alert show={show} handleClose={handleClose} />
    {depotsuccess2 ? <Alert2 message = 'Impossible de postuler, votre candidature a deja été enregistrée' /> : null }
    {depotsuccess ? <Recepisse  dataPerson={data}/> : null}
    {update ? <Update /> : null}
    <div style={{marginBottom: '2rem'}}>
        <div className='mt-3 mb-4' style={{display:'flex','justifyContent':'center'}}>
            <a href={require('../../docs/manuel_prcedure_VE.pdf')} download="Manuel_Procedure_Voyage_ETUDE.pdf" style={{textDecoration: 'none'}}>
                <Button variant='primary' className='px-4 py-3' style={{fontSize: '1.1rem', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', fontWeight: '600', minWidth: '280px'}}>
                    <FontAwesomeIcon icon={faDownload} className='me-2' style={{fontSize: '1.2rem'}} />
                    Télécharger le manuel de procédure
                </Button>
            </a>
        </div>
    </div>
      <div className='container mb-2 voyage' id='mainDepot'>
        {/* {step 1 } */}
        <div className='row'>
            <div className="progress" role="progressbar" aria-label="Animated striped example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
            <div className="progress-bar progress-bar-striped progress-bar-animated" style={{ width: `${calculateProgress()}%` }} ></div>
        </div>
        <div id='nameModule' className=''>
                    <p> {step===1 ? 'Informations personnelles' : 'Partenariat et réseaux de recherche au niveau national et internationnal' }</p>
        </div>
            <div id='form' className={`step step-${step}`}>
            <Form onSubmit={handleSubmit}>
            <div>
                {step === 1 && (
                    <div id="step1" className='mb-3'>
                        <div className="head">
                            <span className='text-bold'>Présentation</span> 
                        </div>
                            <Input type='email' focus={true} value={dataForm.email || ''} label="Adresse mail" name='email' onChange={handleChange} />
                                <div className='row' id='test'>
                                <Input className="col-md-6 col-sm-12" value={dataForm.prenom || ''}  type='text' label="Prénom (s)" name='prenom' onChange={handleChange} />
                                <Input className="col-md-6 col-sm-12" value={dataForm.nom || ''} type='text' label="Nom" name='nom' onChange={handleChange}/>
                                </div>
                                <div className='row'>
                                    {/* {older ? <span style={{color:'red'}}>Le concours  est ouvert aux bacheliers âgés de 22 ans au maximum en 2023.. </span>: null} */}
                                    <Input className="col-md-6 col-sm-12" value={dataForm.matricule || ''} type='text' label="matricule" name='matricule' onChange={handleChange} />
                                <Form.Group id='serie'>
                                <Form.Label className='fw-medium'>Grade <span style={{color:'red'}}>*</span></Form.Label>
                                <Form.Select name='grade' required value={dataForm.grade} onChange={handleChange}>
                                    <option key='' value="" >--- Selectionner ---</option>
                                    <option key='pats' >Professeur Titulaire</option>
                                    <option key='ass' >Professeur Assimilé</option>
                                    <option key='conf' >Maître Conférences Titulaires</option>
                                    <option key='confa' >Maître Conférences Assimilées</option>
                                    <option key='confs' >Maître Conférences Stagiaires</option>
                                </Form.Select>
                            </Form.Group>
                                </div> 
                                <Input className="col-md-12 col-sm-12" value={dataForm.theme_recherche || ''}  type='text' label="Thèmes de recherche" name='theme_recherche' onChange={handleChange} />
                        <div className="head">
                            <span className='text-bold'>Etudes</span> 
                        </div>
                        <div className="row">
                            <div className="col2">
                                <Form.Group id='diplome'>
                                    <Form.Label className='fw-medium'>Diplome<span style={{color:'red'}}>*</span></Form.Label>
                                    <Form.Select name='diplome' required value={dataForm.diplome} onChange={handleChange}>
                                        <option value="" >--- Selectionner ---</option>
                                        <option>Doctorat</option>
                                        <option>Master</option>
                                    </Form.Select>
                                </Form.Group>
                            </div>
                            <div className="col-md-6 col-sm-12" id='labelDiplome'>
                        </div>
                        <Input className="" value={dataForm.etablissement_diplome || ''} type='text' label="Etablissement d'obtention du diplôme" name='etablissement_diplome' onChange={handleChange}/>
                        </div>
                        <div className='row' id='test2'>
                            <Input className="col-md-12 col-sm-12" value={dataForm.date_diplome || ''}  type='date' label="Date d'obtention du diplôme" name='date_diplome' onChange={handleChange} />
                            <Input className="col-md-12 col-sm-12" value={dataForm.lieu_diplome || ''} type='text' label="Lieu d'obtention du diplôme" name='lieu_diplome' onChange={handleChange}/>
                        </div>
                        <div className="head">
                            <span className='text-bold'>Professionnelles</span> 
                        </div>
                        <Form.Group id='serie2'>
                            <Form.Label className='fw-medium'>Fonctions occupées<span style={{color:'red'}}>*</span></Form.Label>
                            <Form.Select name='fonction' required value={dataForm.fonction} onChange={handleChange}>
                                <option key='' value="" >--- Selectionner ---</option>
                                <option key='rec' >Recteur</option>
                                <option key='vice' >Vice-recteur</option>
                                <option key='dir' >Directeur</option>
                                <option key='dire' >Directeur d'école</option>
                                <option key='chefe' >Chef de département</option>
                                <option key='cor' >Coordonnateur</option>
                                <option key='ens' >Enseignent-chercheur</option>
                            </Form.Select>
                        </Form.Group>
                        <Input className="col-md-12 col-sm-12" value={dataForm.date_recrutement || ''}  type='date' label="Date de recrutement" name='date_recrutement' onChange={handleChange} />
                    </div>
                )}
                {/* terminaison de step 1 */}
                {/* step 2 */}
                {step === 2 && (
                <div className='mb-3'>
                    <div className="head">
                        <span>Partenariat et réseaux de recherche au niveau national</span> 
                    </div>
                    <div className="row">
                        <Input required={false} className="col-md-12 col-sm-12" value={dataForm.structure1 || ''}  type='text' label="Nom de la structure 1" name='structure1' onChange={handleChange} />
                        <Input required={false} className="col-md-12 col-sm-12" value={dataForm.naturestructure1 || ''}  type='text' label="Nature de la structure 1" name='naturestructure1' onChange={handleChange} />
                    </div>
                    <div className="row">
                        <Input required={false} className="col-md-12 col-sm-12" value={dataForm.structure2 || ''}  type='text' label="Nom de la structure 2" name='structure2' onChange={handleChange} />
                        <Input required={false} className="col-md-12 col-sm-12" value={dataForm.naturestructure2 || ''}  type='text' label="Nature de la structure 2" name='naturestructure2' onChange={handleChange} />
                    </div>
                    <div className="head">
                            <span>Partenariat et réseaux de recherche au niveau international</span> 
                    </div>
                    <div className="row">
                            <Input required={false} className="col-md-12 col-sm-12" value={dataForm.structureinter1 || ''} placeholder='votre réponse'  type='text' label="Nom de la structure 1" name='structureinter1' onChange={handleChange} />
                            <Input required={false} className="col-md-12 col-sm-12" value={dataForm.naturestructureinter1 || ''} placeholder='votre réponse' type='text' label="Nature de la structure 1" name='naturestructureinter1' onChange={handleChange} />
                        </div>
                        <div className="row">
                            <Input required={false} className="col-md-12 col-sm-12" value={dataForm.structureinter2 || ''} placeholder='votre réponse' type='text' label="Nom de la structure 2" name='structureinter2' onChange={handleChange} />
                            <Input required={false} className="col-md-12 col-sm-12" value={dataForm.naturestructureinter2 || ''} placeholder='votre réponse' type='text' label="Nature de la structure 2" name='naturestructureinter2' onChange={handleChange} />
                        </div>
                    
                </div>
                )}
                {/* terminaison de step 2 */}
                {/* step 3 */}
                {step === 3 && (
                <div className='mb-3'>
                    <Input required={false } className="col-md-12 col-sm-12" value={dataForm.annne_voyage || ''}  type='text' label="Année d'octroi du dernier voyage d'étude" name='annne_voyage' onChange={handleChange} />
                    <Input required={true } className="col-md-12 col-sm-12" value={dataForm.but_voyage || ''}  type='text' label="But du voyage d’étude demandé" name='but_voyage' onChange={handleChange} />
                    <Input required={true } className="col-md-12 col-sm-12" value={dataForm.adresse_etranger || ''}  type='text' label="Adresse complète de l’établissement d’accueil à l’étranger" name='adresse_etranger' onChange={handleChange} />
                    <Input required={true } className="col-md-12 col-sm-12" value={dataForm.responsable_accueil || ''}  type='text' label="Responsable du laboratoire ou du centre d’accueil" name='responsable_accueil' onChange={handleChange} />
                    <Input required={true } className="col-md-12 col-sm-12" value={dataForm.email_responsable || ''}  type='email' label="Adresse e-mail du responsable du laboratoire ou du centre d’accueil" name='email_responsable' onChange={handleChange} />
                    <Input required={true } className="col-md-12 col-sm-12" value={dataForm.adresse_responsable || ''}  type='text' label="Adresse complète du responsable du laboratoire ou du centre d’accueil" name='adresse_responsable' onChange={handleChange} />
                    <InputT type='number' value={dataForm.telephone || ''} label="N° Téléphone du responsable du laboratoire ou du centre d’accueil"  name='telephone' onChange={handleChange} />
                    <Input required={true } className="col-md-12 col-sm-12" value={dataForm.pays || ''}  type='text' label="Pays de destination finale" name='pays' onChange={handleChange} />
                    <Input required={true } className="col-md-12 col-sm-12" value={dataForm.ville_destination || ''}  type='text' label="Ville de destination finale" name='ville_destination' onChange={handleChange} />
                {dataForm.annne_voyage ?
                    <>
                <InputF required={true} className="rounded-left mb-2" label="Compte rendu  du dernier voyage" message={<span style={{color:'red'}}>*</span>} type='file' name='compte_rendu' onChange={(e) => handleFileChange(e,"compte_rendu")} />
                    {!selectedFiles["compte_rendu"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}  
                <InputF required={true} className="rounded-left mb-2" label="Justificatifs du dernier voyage" message={<span style={{color:'red'}}>*</span>} type='file' name='justificatif' onChange={(e) => handleFileChange(e,"justificatif")} />
                    {!selectedFiles["justificatif"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                    <InputF required={true} className="rounded-left mb-2" label="Arrêté rectoral accordant le dernier voyage" type='file' message={<span style={{color:'red'}}>*</span>} name='arrete' onChange={(e) => handleFileChange(e,"arrete")} />
                    {!selectedFiles["arrete"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                    </>
                 : null}
                
                </div>
                )}
           </div>
           {erreur ? <><div className="alert alert-danger" role="alert">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" fill="currentColor" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                                <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                                </svg> Vous n'etes pas autorisé à déposer
                            </div></> : null}
           {errors ? <><div className="alert alert-danger" role="alert">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" fill="currentColor" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                                <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                                </svg> Veuiler remplir tous les champs
                            </div></> : null}
           <div className="buttons">
            {step > 1 && (
                <Button variant='primary' className='float-start mb-2' size="md" onClick={handlePreviousStep}>Précedent</Button>
            )}
            {step < 3 && (
                <Button className='float-end mb-2' variant='primary' size="md" onClick={handleNextStep}>Suivant</Button>
            )}
            {step === 3 && 
                <Button  variant="primary" type='submit' size="md"
                // disabled={!ok}
                    className="p-2 float-end mb-2">
                    Valider  {submitted ?
                        <Spinner animation="grow"
                        size="sm" role="status"
                        >
                        <span className="visually-hidden">Loading...</span>
                        </Spinner>
                        : null}
                </Button>
            }
            </div>
          </Form>
        </div>
        </div>
      </div>
    </>
  )
}
export default Voyage